import apiClient from 'services/_infra/apiClient';

export async function GetIFrameSource(deviceId) {
  try {
    const response = await apiClient.get(`/getMaintenanceUrls/${deviceId}`);
    return response.data.result;
  } catch (error) {
    console.error('Error in GetIFrameSource');
  }
}

export async function GetPowerMaintenanceURL(deviceId) {
  try {
    const response = await apiClient.get(`/getGroupMaintenanceUrls_v2/${deviceId}`);

    return response.data.result;
  } catch (error) {
    console.error('clicked button Error in GetPowerMaintenanceURL:', error);
  }
}

export async function GetTechBridgeMaintenanceURL(deviceId) {
  try {
    const response = await apiClient.get(
      `/v2/integrations/device/${deviceId}/maintenance/maintenance-urls`,
    );

    return response.data.result;
  } catch (error) {
    console.error('clicked button Error in GetTechBridgeMaintenanceURL:', error);
  }
}
